import React from 'react';

const CareerIcon = () => {
      return <span className="material-symbols-outlined">book</span>;
};

export default CareerIcon;
